<template>
  <!-- "Favorites" button -->
  <button id="custom-button" class="rounded-0 w-20 btn text-white border-0">
    <div class="text-center " >
      <span class="px-1" >{{ FavBtnText }}</span>
      <span class="px-1">
        <span v-if="toggle" ><i class="fa-solid fa-angle-down toggle-up" ></i></span>
        <span v-if="!toggle" ><i class="fa-solid fa-angle-up toggle-down" ></i></span>
      </span>
    </div>
<!--    {{ (toggle) }}-->
  </button>
</template>

<script>

export default {
  props: [
      'toggle',
  ],
  data() {
    return {
      FavBtnText: 'Favorites',
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
//@import "favorite-button";
</style>